<template>
  <div class="modal fade" id="mod-purchase-order-filter" role="dialog">
    <div class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end">
      <form @submit.prevent="submit"
        class="modal-content rounded-none bg-[#f8f8f8] p-[20px] md:p-[40px] md:min-h-screen">
        <div class="modal-header flex items-start justify-between p-0 m-0">
          <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
            Filter
          </h4>
          <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true">
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="modal-body m-0 p-0">
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Start Date</label>
            <div>
              <input type="date" :max="maxDate" placeholder="Select a date" v-model="filter.startDate"
                class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none" />
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">End Date</label>
            <div>
              <input type="date" :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                placeholder="Select a date" v-model="filter.endDate" />
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">DIstributor Name</label>
            <div>
              <input @input="setCustomerName($event.target.value)"
                class="bg-transparent border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full" type="text"
                placeholder="Filter by name" :value="filter.customerName" />
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">PO Number</label>
            <div>
              <input @input="setOrderNumber($event.target.value)"
                class="bg-transparent border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full" type="text"
                placeholder="Filter by PO Number" :value="filter.poNumber" />
            </div>
          </div>
          <div>
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Status</label>
            <div>
              <select
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                v-model="filter.status">
                <option v-for="option in statusItem" :key="option.value" :value="option.value">
                  {{ option.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-[8px] w-full mt-[24px]">
          <button
            class="bg-transparent border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
            type="button" data-dismiss="modal">
            Clear
          </button>
          <button
            class="bg-transparent border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
            type="button" @click="clearFilter">
            Reset
          </button>
          <button
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
            type="submit">
            {{ isBusyModal ? "Loading..." : "Search" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import datePicker from "vue-bootstrap-datetimepicker";
import { mapState } from "vuex";
import { helper } from "@/helper";
import moment from "moment";

export default {
  name: "ManufacturerFilterPurchaseOrder",
  components: {
    datePicker,
  },
  props: ["isBusyModal"],
  data() {
    return {
      maxDate: "",
      statusItem: [
        { name: "Submitted", value: "submitted" },
        { name: "Approved", value: "approved" },
        { name: "Rejected", value: "rejected" },
        { name: "Completed", value: "closed" },
      ],
      groups: [],
      orderStages: [],
      status: [],
      showDeactivated: "",
      downloadItems: [
        { name: "YES", value: true },
        { name: "NO", value: false },
      ],

      readItems: [
        { name: "READ", value: true },
        { name: "NOT READ", value: false },
      ],
    };
  },

  created() {
    this.getOrderStages();
  },

  mounted() {
    this.getGroups();
  },

  computed: {
    ...mapState(["filter"]),
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },
  methods: {
    setCustomerName(date) {
      this.filter.customerName = date;
      this.updateFilter(this.filter);
    },
    setOrderNumber(number) {
      this.filter.poNumber = number;
      this.updateFilter(this.filter);
    },
    setReadStatus(status) {
      this.filter.readStatus = status;
      this.updateFilter(this.filter);
    },
    setStage(stage) {
      this.filter.selectedStage = stage;
      this.updateFilter(this.filter);
    },
    setDownloadStatus(download) {
      this.filter.downloadStatus = download;
      this.updateFilter(this.filter);
    },
    setGroup(group) {
      this.filter.group = group;
      this.updateFilter(this.filter);
    },
    setStatus(status) {
      this.filter.status = status;
      this.updateFilter(this.filter);
    },
    updateFilter(filter) {
      this.$store.commit("updateFilter", filter);
    },
    clearFilter() {
      this.$store.commit("clearFilter");
      this.$emit("onClear");
    },
    async getOrderStages() {
      try {
        const response = await this.$http.get(
          "/PurchaseOrders/orderStage/getList?active=true"
        );

        if (response.ok && response.status === 200) {
          this.orderStages = response.body.sort(
            (firstItem, secondItem) => firstItem.stage - secondItem.stage
          );
        }
      } catch (error) { }
    },

    dateTimeValue() {
      const now = new Date();
      const utcString = now.toISOString().substring(0, 19);
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const hour = now.getHours();
      const minute = now.getMinutes();
      const localDatetime =
        year +
        "-" +
        (month < 10 ? "0" + month.toString() : month) +
        "-" +
        (day < 10 ? "0" + day.toString() : day) +
        "T" +
        (hour < 10 ? "0" + hour.toString() : hour) +
        ":" +
        (minute < 10 ? "0" + minute.toString() : minute) +
        utcString.substring(16, 19);

      return localDatetime;
    },

    setDateTime() {
      return this.dateTimeValue();
    },

    submit() {
      this.$emit("onFilter", {
        startDate: this.filter.startDate || '',
        endDate: this.filter.endDate || '',
        status: this.filter.status,
      });
    },

    async getGroups() {
      try {
        const response = await this.$http.get(
          `/Groups/getListNoPaging?active=${this.showDeactivated}`
        );

        if (response.ok && response.status === 200) {
          this.groups = response.body;
        }
      } catch (error) { }
    },
  },
};
</script>